module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/face-bade91b05a26c951b34eb24daebbfdd8.png";